var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Part4"},[_c('div',{staticClass:"w"},[_c('div',{staticClass:"titleBlack"},[_c('div',[_vm._v("GIS地图与保险融合")]),_c('div',{staticClass:"tipBlack"},[_vm._v("利用GIS地图技术与农业保险相结合，稳定农民收入，促进经济发展")])]),_c('img',{attrs:{"src":require("@/assets/image/solution/gis/part4@2x.png"),"alt":""}})])])
}]

export { render, staticRenderFns }